import canadianProvinces from 'static/addresses/canadianProvinces'
import usStates from 'static/addresses/usStates'

export function sorter(type, a, b) {
  if (type === 'displayId') {
    return a.displayId - b.displayId
  }

  if (type === 'updatedOn') {
    return new Date(b.updatedOn) - new Date(a.updatedOn)
  }

  if (type === 'addedOn') {
    return new Date(b.addedOn) - new Date(a.addedOn)
  }

  if (type === 'city') {
    if (a.city < b.city) {
      return -1
    }
    if (a.city > b.city) {
      return 1
    }
    return 0
  }

  if (type === 'state') {
    const stateA = { ...usStates, ...canadianProvinces }?.[a.stateCode]

    const stateB = { ...usStates, ...canadianProvinces }?.[b.stateCode]

    if (stateA < stateB) {
      return -1
    }
    if (stateA > stateB) {
      return 1
    }
    return 0
  }

  if (type === 'be') {
    if (a.bookingEngine < b.bookingEngine) {
      return -1
    }
    if (a.bookingEngine > b.bookingEngine) {
      return 1
    }
    return 0
  }

  if (type === 'chain') {
    if (a.chainCode < b.chainCode) {
      return -1
    }
    if (a.chainCode > b.chainCode) {
      return 1
    }
    return 0
  }

  return 0
}

export const sortOptions = {
  updatedOn: 'Updated on',
  addedOn: 'Added on',
  be: 'Booking engine',
  chain: 'Chain',
  displayId: 'Display id'
}

export function filterAndSort(
  hotels,
  searchQuery,
  includeDeleted,
  selectedChain,
  selectedParentChain,
  selectedGroup,
  sortParam,
  selectedState,
  selectedCity
) {
  if (hotels && hotels.filter) {
    return hotels
      .filter(h => (includeDeleted ? true : !h.isDeleted))
      .filter(h => (selectedChain === 'all' ? true : h.chainCode === selectedChain))
      .filter(h =>
        selectedParentChain === 'all' ? true : h.parentChainCode === selectedParentChain
      )
      .filter(h => (selectedGroup === 'all' ? true : h.merchantName === selectedGroup))
      .filter(h => h.searchString?.toLowerCase().includes(searchQuery.toLowerCase()))
      .filter(h => {
        if (selectedState === 'all') {
          return true
        }

        return h.stateCode === selectedState
      })
      .filter(h => {
        if (selectedCity === 'all') {
          return true
        }

        return h.city === selectedCity
      })

      .sort((a, b) => sorter(sortParam, a, b))
  }

  return []
}
